import { atom, selector } from "recoil";
import { ApiClient } from "TaxAnalyticsHelpers";

interface SnackbarState {
    open: boolean;
    message: string;
    severity: "error" | "warning" | "info" | "success"
}

export const portalState = atom({
    key: "portalState",
    default: {},
});

export const snackbarState = atom<SnackbarState>({
    key: "snackbarState",
    default: {
        open: false,
        message: "",
        severity: "info"
    },
});

export const serviceOffersState = selector({
    key: 'serviceOffersState',
    get: async () => {
        const response = await ApiClient.serviceOffer.serviceOffers();
        return response;
    }
});
